__turbopack_context__.v({
  "blok-big-title": "goodsans_57ec6de9-module__zhmeca__blok-big-title",
  "blok-subtitle": "goodsans_57ec6de9-module__zhmeca__blok-subtitle",
  "blok-title": "goodsans_57ec6de9-module__zhmeca__blok-title",
  "className": "goodsans_57ec6de9-module__zhmeca__className",
  "variable": "goodsans_57ec6de9-module__zhmeca__variable",
});
